<style lang="scss">
/* ===== Layout ===== */
.page-inner {
    max-width: 1200px;
    margin: 0 auto;
}

/* ===== Table Card ===== */
.table-card {
    border-radius: 8px;

    :deep(.ant-card-head) {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        min-height: 48px;
    }

    :deep(.ant-card-body) {
        padding: 0 16px 16px;
    }
}

.card-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.card-title-text {
    font-weight: 600;
    font-size: 14px;
}

/* ===== Toolbar ===== */
.table-toolbar {
    padding: 12px 16px;
    background: #fafafa;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    gap: 8px;
    align-items: center;
}

/* ===== PC vs Mobile Toggle ===== */
.carmine-card-list {
    display: none;
    gap: 12px;

    .carmine-mobile-card {
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

        :deep(.ant-card-body) {
            padding: 12px 14px;
        }
    }

    .carmine-mobile-card.row-unused {
        background: #f6ffed;
    }

    .carmine-mobile-card.row-used {
        background: #fff1f0;
    }

    .carmine-mobile-card.row-disabled {
        background: #f5f5f5;
    }

    .mobile-card-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;
    }

    .mobile-card-title {
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.88);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
        font-family: monospace;
    }

    .mobile-card-body {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .mobile-field {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
    }

    .mobile-label {
        color: rgba(0, 0, 0, 0.45);
        min-width: 72px;
        flex-shrink: 0;
        font-size: 12px;
    }

    .mobile-value {
        color: rgba(0, 0, 0, 0.88);
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

/* ===== Pagination ===== */
.table-pagination {
    display: flex;
    justify-content: flex-end;
    padding-top: 12px;
}

/* ===== Row Status ===== */
:deep(.row-unused)>td {
    background: #f6ffed !important;
}

:deep(.row-used)>td {
    background: #fff1f0 !important;
}

:deep(.row-disabled)>td {
    background: #f5f5f5 !important;
}

/* ===== Money display ===== */
.money_total_num {
    color: #ff4d4f;
    font-weight: 600;
    font-size: 16px;
    margin-left: 8px;
}

/* ===== Carmine Show ===== */
.show-carmine-div {
    background-color: black;
    color: white;
    overflow: auto;
    padding: 16px;
    border-radius: 4px;
    font-family: monospace;
    font-size: 14px;
    line-height: 1.8;
}

/* ===== Mobile Responsive ===== */
@media screen and (max-width: 768px) {

    .carmine-table-pc,
    .table-pagination {
        display: none !important;
    }

    .carmine-card-list {
        display: flex !important;
        flex-direction: column;
    }

    .table-card :deep(.ant-card-head) {
        padding: 0 12px;
        min-height: 44px;
    }

    .table-card :deep(.ant-card-body) {
        padding: 0 12px 12px;
    }

    .table-toolbar {
        padding: 10px 12px;
        flex-wrap: wrap;
    }
}

@media screen and (max-width: 480px) {
    .mobile-label {
        min-width: 60px;
        font-size: 11px;
    }

    .mobile-value {
        font-size: 12px;
    }
}
</style>

<template>
    <a-layout style="min-height: 100vh;">
        <UserHead />
        <a-layout>
            <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
                <div class="page-inner">
                    <a-card :bordered="false" class="table-card">
                        <template #title>
                            <div class="card-title-row">
                                <span class="card-title-text">卡密列表</span>
                                <a-tag color="blue">{{ total }} 条</a-tag>
                            </div>
                        </template>

                        <div class="table-toolbar">
                            <a-button type="primary" @click="toAddCarmineDialog">生成卡密</a-button>
                            <a-button type="primary" @click="toUseCarmine">使用卡密</a-button>
                        </div>

                        <a-table class="carmine-table-pc" :data-source="carmineList" :pagination="false" row-key="id"
                            :scroll="{ x: 1000 }" size="small" bordered :loading="tableLoading" :columns="tableColumns"
                            :row-class-name="getRowClass">
                            <template #bodyCell="{ column, record }">
                                <template v-if="column.key === 'state'">
                                    <a-tag v-if="record.state == 1" color="green">未使用</a-tag>
                                    <a-tag v-else-if="record.state == 0" color="red">已使用</a-tag>
                                    <a-tag v-else-if="record.state == -1" color="default">已禁用</a-tag>
                                </template>
                                <template v-else-if="column.key === 'timeUnit'">
                                    {{ getTimeUnit(record.timeUnit) }}
                                </template>
                            </template>
                        </a-table>

                        <!-- 手机端卡片列表 -->
                        <div class="carmine-card-list" v-if="carmineList && carmineList.length > 0">
                            <a-card v-for="record in carmineList" :key="record.id" class="carmine-mobile-card"
                                :bordered="false" :class="getRowClass(record)">
                                <div class="mobile-card-head">
                                    <div class="mobile-card-title">{{ record.carmine }}</div>
                                    <a-tag v-if="record.state == 1" color="green" size="small">未使用</a-tag>
                                    <a-tag v-else-if="record.state == 0" color="red" size="small">已使用</a-tag>
                                    <a-tag v-else-if="record.state == -1" color="default" size="small">已禁用</a-tag>
                                </div>
                                <div class="mobile-card-body">
                                    <div class="mobile-field">
                                        <span class="mobile-label">ID</span>
                                        <span class="mobile-value">{{ record.id }}</span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">使用者</span>
                                        <span class="mobile-value">{{ record.usedUid || '-' }}</span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">使用时间</span>
                                        <span class="mobile-value">{{ record.usedTime || '-' }}</span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">类型</span>
                                        <span class="mobile-value">{{ getTimeUnit(record.timeUnit) }}</span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">插件</span>
                                        <span class="mobile-value">{{ record.pluginName || '-' }} v{{ record.versionName
                                            }}</span>
                                    </div>
                                </div>
                            </a-card>
                        </div>

                        <!-- 分页 -->
                        <div class="table-pagination">
                            <a-pagination v-model:current="currentPage" v-model:page-size="pageSize"
                                :page-size-options="[10, 20, 30, 40]" show-size-changer show-quick-jumper
                                :show-total="(total) => `共 ${total} 条`" :total="total" @change="handleCurrentChange" />
                        </div>
                    </a-card>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>

    <!-- 生成卡密对话框 -->
    <a-modal v-model:open="addCarmineDialog.isShow" title="生成卡密" :width="520" centered>
        <div style="padding: 8px;">
            <div style="margin-bottom: 12px;">
                <span style="display:block; margin-bottom: 4px; font-size: 13px; color: rgba(0,0,0,0.65);">选择插件</span>
                <a-select v-model:value="addCarmineDialog.plugin" style="width: 100%;"
                    @change="getTimeMealAndVersions(addCarmineDialog.plugin)" placeholder="请选择插件">
                    <a-select-option v-for="(item) in addCarmineDialog.includes_list" :key="item.includes_id"
                        :value="item.includes_id">{{ item.includes_id + '---' + item.includes_name + '---' +
                            item.grade_name
                        }}</a-select-option>
                    <a-select-option v-if="addCarmineDialog.includes_list.length == 0"
                        disabled>--暂无插件/您不是任何插件的代理--</a-select-option>
                </a-select>
            </div>
            <div v-if="addCarmineDialog.version_list.length > 1" style="margin-bottom: 12px;">
                <span style="display:block; margin-bottom: 4px; font-size: 13px; color: rgba(0,0,0,0.65);">选择版本</span>
                <a-select v-model:value="addCarmineDialog.version" style="width: 100%;"
                    @change="getTimeMeal(addCarmineDialog.plugin)" placeholder="请选择版本">
                    <a-select-option v-for="item in addCarmineDialog.version_list"
                        :key="'version_select_' + item.version" :value="item.version">{{ item.name }}</a-select-option>
                </a-select>
            </div>
            <div style="margin-bottom: 12px;">
                <span style="display:block; margin-bottom: 4px; font-size: 13px; color: rgba(0,0,0,0.65);">选择时长类型</span>
                <a-select v-model:value="addCarmineDialog.time" style="width: 100%;"
                    @change="setTimeMeal(addCarmineDialog.time)" placeholder="请选择时长单位">
                    <a-select-option v-for="(item) in addCarmineDialog.time_meal_list" :key="item.meal_id"
                        :value="item.meal_id">{{ item.time_unit + '---' + item.price + '元' }}</a-select-option>
                </a-select>
            </div>
            <div style="margin-bottom: 12px;">
                <span style="display:block; margin-bottom: 4px; font-size: 13px; color: rgba(0,0,0,0.65);">卡密数量</span>
                <a-input-number v-model:value="addCarmineDialog.num" style="width: 100%;" placeholder="请输入卡密数量" />
            </div>
            <div style="margin-bottom: 8px;">
                <span style="font-size: 13px; color: rgba(0,0,0,0.65);">共计</span>
                <span class="money_total_num">{{ (addCarmineDialog.price * addCarmineDialog.num).toFixed(2) }}元</span>
            </div>
        </div>
        <template #footer>
            <a-button @click="addCarmineDialog.isShow = false">取消</a-button>
            <a-button type="primary" @click="addCarmineConfirm()">生成</a-button>
        </template>
    </a-modal>

    <!-- 卡密详情对话框 -->
    <a-modal v-model:open="showCarmineDialog.isShow" title="卡密详情" :width="520" centered>
        <div class="show-carmine-div">
            <div>以下是您的卡密信息：</div>
            <div v-for="(item, i) in showCarmineDialog.list" :key="i">{{ item }}</div>
        </div>
        <template #footer>
            <a-button type="primary" @click="showCarmineDialog.isShow = false">确定</a-button>
        </template>
    </a-modal>
</template>

<script>
import { defineComponent, ref } from 'vue';
import { message, Modal } from 'ant-design-vue';
import UserHead from '@/components/UserHead.vue';
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import router from '@/router';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
    },
    data() {
        return {
            tableLoading: false,
            carmineList: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            columns: [
                { title: 'ID', dataIndex: 'id', key: 'id', width: 80, align: 'center' },
                { title: '卡密', dataIndex: 'carmine', key: 'carmine', width: 200 },
                { title: '状态', dataIndex: 'state', key: 'state', width: 100 },
                { title: '使用者UID', dataIndex: 'usedUid', key: 'usedUid', width: 100 },
                { title: '使用时间', dataIndex: 'usedTime', key: 'usedTime', width: 160 },
                { title: '类型', dataIndex: 'timeUnit', key: 'timeUnit', width: 80 },
                { title: '插件', dataIndex: 'pluginName', key: 'pluginName', width: 140 },
                { title: '插件版本', dataIndex: 'versionName', key: 'versionName', width: 100 }
            ],
            addCarmineDialog: {
                isShow: false,
                plugin: '',
                time: '',
                num: 1,
                price: 0.0,
                version: 1,
                includes_list: [],
                time_meal_list: [],
                version_list: []
            },
            showCarmineDialog: {
                isShow: false,
                list: []
            }
        };
    },
    computed: {
        tableColumns() {
            return [
                { title: 'ID', dataIndex: 'id', key: 'id', width: 80, align: 'center' },
                { title: '卡密', dataIndex: 'carmine', key: 'carmine', width: 200 },
                { title: '状态', key: 'state', width: 100 },
                { title: '使用者UID', dataIndex: 'usedUid', key: 'usedUid', width: 100 },
                { title: '使用时间', dataIndex: 'usedTime', key: 'usedTime', width: 160 },
                { title: '类型', key: 'timeUnit', width: 80 },
                { title: '插件', dataIndex: 'pluginName', key: 'pluginName', width: 140 },
                { title: '插件版本', dataIndex: 'versionName', key: 'versionName', width: 100 }
            ];
        }
    },
    methods: {
        getRowClass(record) {
            if (record.state == 1) return 'row-unused';
            if (record.state == 0) return 'row-used';
            return 'row-disabled';
        },
        fetchCarmineList() {
            this.tableLoading = true;
            axios.post(baseURL + '/carmine/list',
                { currentPage: this.currentPage, pageSize: this.pageSize },
                {
                    timeout: 10000,
                    headers: { 'token': localStorage.getItem("token") }
                }).then(response => {
                    if (response.data.code == 200) {
                        this.carmineList = response.data.data.list;
                        this.total = response.data.data.total;
                    } else if (response.data.code == 401) {
                        message.error(response.data.msg)
                        setTimeout(() => { location.href = "/Login" }, 1000);
                    } else {
                        message.error(response.data.msg)
                    }
                }).catch(error => {
                    console.error('获取卡密列表失败:', error);
                }).finally(() => {
                    this.tableLoading = false;
                });
        },
        getTimeMealAndVersions(includes_id) {
            openLoading()
            const headers = { 'token': localStorage.getItem("token") }
            var data = new FormData()
            data.append("includes_id", includes_id)
            axios.post(baseURL + "/userApi/getGradeTimeMeal", data, { timeout: 5000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 401) {
                        message.error('您没有登录')
                        setTimeout(() => { location.href = "/Login" }, 1000);
                        return
                    } else if (res.data.code == 200) {
                        const versions_data = res.data.data.data;
                        this.addCarmineDialog.version_list = []
                        this.addCarmineDialog.version = 1
                        versions_data.forEach((version_item) => {
                            const version_name = version_item.version_name || `版本 ${version_item.version}`;
                            this.addCarmineDialog.version_list.push({
                                name: version_name,
                                version: version_item.version,
                                desc: version_item.version_desc || '',
                                meals: version_item.grade_arr
                            });
                        });
                        this.getTimeMeal(includes_id)
                    } else {
                        message.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    message.error('获取版本和价格信息失败：' + err.message)
                })
        },
        handleSizeChange(current, size) {
            this.currentPage = current;
            this.pageSize = size;
            this.fetchCarmineList();
        },
        handleCurrentChange(val, pageSize) {
            this.currentPage = val;
            if (pageSize !== undefined) this.pageSize = pageSize;
            this.fetchCarmineList();
        },
        toUseCarmine() {
            router.push('/CarmineUse');
        },
        getTimeUnit(type) {
            if (type == 'day') return '天'
            else if (type == 'month') return '月'
            else if (type == 'year') return '年'
            else if (type == 'forever') return '永久'
            else return '未知'
        },
        toAddCarmineDialog() {
            this.addCarmineDialog.isShow = true;
            this.getIncludesList()
        },
        getIncludesList() {
            openLoading()
            const headers = { 'token': localStorage.getItem("token") }
            var data = new FormData()
            data.append("act", 'getEmpowerIncludesList')
            axios.post(baseURL + "/userApi/getIncludesAgent", data, { timeout: 5000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 401) {
                        message.error(res.data.msg)
                        setTimeout(() => { location.href = "/Login" }, 1000);
                        return
                    } else if (res.data.code == 200) {
                        this.addCarmineDialog.includes_list = res.data.data;
                    } else {
                        message.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    message.error('获取代理插件列表失败：' + err.message)
                })
        },
        getTimeMeal(includes_id) {
            openLoading()
            const data = new FormData();
            const headers = { 'token': localStorage.getItem("token") }
            data.append("includes_id", includes_id)
            data.append("version", this.addCarmineDialog.version)
            data.append("act", "getTimeMeal")
            axios.post(baseURL + "/userApi/getInfo", data, { timeout: 5000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 401) {
                        message.error('您没有登录')
                        setTimeout(() => { location.href = "/Login" }, 1000);
                    } else if (res.data.code == 200) {
                        this.addCarmineDialog.time_meal_list = res.data.data
                    } else {
                        message.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    message.error('请求失败：' + err.message)
                })
        },
        setTimeMeal(time) {
            var element = this.addCarmineDialog.time_meal_list.filter(item => item.meal_id == time);
            this.addCarmineDialog.num = 1
            this.addCarmineDialog.price = element[0].price
        },
        addCarmine() {
            openLoading();
            const headers = { 'token': localStorage.getItem("token") };
            axios.post(baseURL + "/carmine/add", {
                pluginId: this.addCarmineDialog.plugin,
                mealId: this.addCarmineDialog.time,
                num: this.addCarmineDialog.num,
                version: this.addCarmineDialog.version
            }, { timeout: 10000, headers: headers })
                .then(res => {
                    fullscreenLoading.close()
                    if (res.data.code == 401) {
                        message.error('您没有登录')
                        setTimeout(() => { location.href = "/Login" }, 1000);
                    } else if (res.data.code == 200) {
                        this.showCarmineDialog.isShow = true;
                        this.addCarmineDialog.isShow = false;
                        this.showCarmineDialog.list = res.data.data.list
                    } else {
                        message.error(res.data.msg)
                    }
                })
                .catch(err => {
                    fullscreenLoading.close()
                    console.log(err)
                    message.error('请求失败：' + err.message)
                })
        },
        addCarmineConfirm() {
            Modal.confirm({
                title: '确定生成卡密？',
                content: '',
                okText: '确定',
                cancelText: '关闭',
                iconType: 'warning',
                onOk: () => { this.addCarmine(); }
            })
        }
    },
    created() {
        this.fetchCarmineList();
    }
})
</script>
